import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { TUserSubscriptionPaymentHistory } from "../../Types";

export const apiCallGetUserPaymentsByUserID = async ({
  userId,
  limit
}: {
  userId: number;
  limit: number;
}): Promise<{
  data: {
    silverSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    goldSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    blackSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    platinumSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    powerBundleSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    readSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    vipSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    plusSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    khattabatSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    boostSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    rewindSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    otherSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    userID: number;
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    silverSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    goldSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    blackSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    platinumSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    powerBundleSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    readSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    vipSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    plusSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    khattabatSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    boostSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    rewindSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    otherSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    userID: number;
  }>(`user/getPaymentsByUserId`, {
    userId,
    limit
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        silverSubscriptionPaymentHistory: [],
        goldSubscriptionPaymentHistory: [],
        blackSubscriptionPaymentHistory: [],
        platinumSubscriptionPaymentHistory: [],
        powerBundleSubscriptionPaymentHistory: [],
        readSubscriptionPaymentHistory: [],
        vipSubscriptionPaymentHistory: [],
        plusSubscriptionPaymentHistory: [],
        khattabatSubscriptionPaymentHistory: [],
        boostSubscriptionPaymentHistory: [],
        rewindSubscriptionPaymentHistory: [],
        otherSubscriptionPaymentHistory: [],
        userID: -1
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        silverSubscriptionPaymentHistory: [],
        goldSubscriptionPaymentHistory: [],
        blackSubscriptionPaymentHistory: [],
        platinumSubscriptionPaymentHistory: [],
        powerBundleSubscriptionPaymentHistory: [],
        readSubscriptionPaymentHistory: [],
        vipSubscriptionPaymentHistory: [],
        plusSubscriptionPaymentHistory: [],
        khattabatSubscriptionPaymentHistory: [],
        boostSubscriptionPaymentHistory: [],
        rewindSubscriptionPaymentHistory: [],
        otherSubscriptionPaymentHistory: [],
        userID: -1
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};

export const apiCallGetUserPaymentsByTransactionId = async ({
  transactionId,
  limit
}: {
  transactionId: string;
  limit: number;
}): Promise<{
  data: {
    silverSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    goldSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    blackSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    platinumSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    powerBundleSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    readSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    vipSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    plusSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    khattabatSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    boostSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    rewindSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    otherSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    userID: number;
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    silverSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    goldSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    blackSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    platinumSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    powerBundleSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    readSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    vipSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    plusSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    khattabatSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    boostSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    rewindSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    otherSubscriptionPaymentHistory: TUserSubscriptionPaymentHistory;
    userID: number;
  }>(`user/getPaymentsByTransactionId`, {
    transactionId,
    limit
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        silverSubscriptionPaymentHistory: [],
        goldSubscriptionPaymentHistory: [],
        blackSubscriptionPaymentHistory: [],
        platinumSubscriptionPaymentHistory: [],
        powerBundleSubscriptionPaymentHistory: [],
        readSubscriptionPaymentHistory: [],
        vipSubscriptionPaymentHistory: [],
        plusSubscriptionPaymentHistory: [],
        khattabatSubscriptionPaymentHistory: [],
        boostSubscriptionPaymentHistory: [],
        rewindSubscriptionPaymentHistory: [],
        otherSubscriptionPaymentHistory: [],
        userID: -1
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        silverSubscriptionPaymentHistory: [],
        goldSubscriptionPaymentHistory: [],
        blackSubscriptionPaymentHistory: [],
        platinumSubscriptionPaymentHistory: [],
        powerBundleSubscriptionPaymentHistory: [],
        readSubscriptionPaymentHistory: [],
        vipSubscriptionPaymentHistory: [],
        plusSubscriptionPaymentHistory: [],
        khattabatSubscriptionPaymentHistory: [],
        boostSubscriptionPaymentHistory: [],
        rewindSubscriptionPaymentHistory: [],
        otherSubscriptionPaymentHistory: [],
        userID: -1
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
